import React from "react";

export const usageText = (u) => (u?.kind === 'link'
    ? `LaserLink "${u.label}"${u.pops?.length ? ` (${u.pops.join(', ')})` : ''}`
    : `ClickPop from ${u?.label}`);

const savedAgo = (iso) => {
    const secs = (Date.now() - new Date(iso).getTime()) / 1000;
    if (!iso || !Number.isFinite(secs)) return null;
    if (secs < 60) return 'last saved just now';
    if (secs < 3600) return `last saved ${Math.floor(secs / 60)} min ago`;
    if (secs < 86400) return `last saved ${Math.floor(secs / 3600)} h ago`;
    const days = Math.floor(secs / 86400);
    return `last saved ${days} day${days > 1 ? 's' : ''} ago`;
};

const LightBoxUsages = ({ usages = [], createdBy, updatedAt }) => {
    const meta = [createdBy && `Created by ${createdBy}`, savedAgo(updatedAt)].filter(Boolean).join(' · ');
    return (
        <>
            {usages.length > 0 ? (
                <div className="lb-usages">
                    {usages.map((u) => (
                        <span key={`${u.kind}-${u.id}`} className="lb-usage-chip">{usageText(u)}</span>
                    ))}
                </div>
            ) : (
                <p className="lb-muted mb-0">Not used by any element or LaserLink.</p>
            )}
            {meta && <p className="lb-muted mt-2 mb-0">{meta}</p>}
        </>
    );
};

export default LightBoxUsages;
